import {combineReducers} from 'redux';
import enrolledList from './enrolledList';
import allTalentList from './allTalentList';
import goSurveyResults from './goSurveyResult';
import enrolledProgram from './enrolledProgram';
import programEnrollments from './programEnrollments';
import emergingTalentGraph from './emergingTalentGraph';
import careerFavoritesList from './careerFavoritesList';
import programFavoritesList from './programFavoritesList';
import topProgramEnrollments from './topProgramEnrollments';
import recruitmentInsightMetrics from './recruitmentInsightMetrics';

export const talentInsightsReducer = combineReducers({
  enrolledList: enrolledList,
  allTalentList: allTalentList,
  goSurveyResults: goSurveyResults,
  enrolledProgram: enrolledProgram,
  programEnrollments: programEnrollments,
  careerFavoritesList: careerFavoritesList,
  emergingTalentGraph: emergingTalentGraph,
  programFavoritesList: programFavoritesList,
  topProgramEnrollments: topProgramEnrollments,
  recruitmentInsightMetrics: recruitmentInsightMetrics,
});
